import AdminLayout from '../components/AdminLayout';
import WhatsAppTemplatesSection from '../components/WhatsAppTemplatesSection';
import { apiFetch } from '../lib/api';

export default function AdminWhatsAppCenter() {
  const waFetch = (path: string, init?: RequestInit) =>
    apiFetch(`/api/public/admin/whatsapp${path}`, init);

  return (
    <AdminLayout currentPage="WhatsApp 中心">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">WhatsApp 中心</h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
          管理 Meta 官方模板、變數對應、發送渠道與測試發送。
        </p>
      </div>
      <WhatsAppTemplatesSection apiFetch={waFetch} />
    </AdminLayout>
  );
}
